import type { FC, PropsWithChildren } from 'react';

import { useProcessingContext } from '@/providers/ProcessingProvider/ProcessingProviderContext';

import * as S from './Processing.styles';

export const Processing: FC<PropsWithChildren> = ({ children }) => {
  const { isProcessing } = useProcessingContext();
  return (
    <S.Wrapper
      $isProcessing={!!isProcessing}
      className='content'
      data-test-id='ProcessingContent'
    >
      {isProcessing && <S.Loader size='lg' thickness={4} />}
      {children}
    </S.Wrapper>
  );
};
